/* import __COLOCATED_TEMPLATE__ from './sq-progress-bar.hbs'; */
/**

## Progress bar

```example
@title Simple Example

@controller-properties
{
  progress: 0.5,
  statusText: 'Doing something...'
}

@hbs
{{sq-progress-bar progress=progress statusText=statusText}}
```

```example
@title Hide Percentage Variant

@controller-properties
{
  progress: 0.75,
  statusText: 'Doing something...',
  showPercentage: false
}

@hbs
{{sq-progress-bar progress=progress statusText=statusText showPercentage=showPercentage}}
```

```example
@title Micro Size

@controller-properties
{
  progress: 0.25,
  showPercentage: false
}

@hbs
{{sq-progress-bar progress=progress showPercentage=showPercentage class="sq-progress-bar--micro"}}
```

@param {number} [progress=0.0] - Progress value between 0.0 and 1.0
@param {String} [statusText=null] - Optional status message to display below the progress bar
@param {Boolean} [showPercentage=true] - Boolean to decide whether the percentage is visible

Sass dependencies at: `app/assets/stylesheets/dashboard/components/_sq-progress-bar.sass`
*/

import { htmlSafe } from '@ember/template';
import { computed } from '@ember/object';
import Component from '@ember/component';

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  classNames: ['sq-progress-bar'],
  // Passed in:
  // Should be within [0.0, 1.0]
  progress: 0,
  statusText: null,
  showPercentage: true,
  percent: computed('progress', function () {
    let progress = this.get('progress');
    if (!progress || progress < 0) {
      return 0;
    } else if (progress > 1) {
      progress = 1;
    }
    return progress * 100;
  }),
  percentStyle: computed('percent', function () {
    return htmlSafe(`width: ${this.get('percent')}%`);
  })
});